import React from 'react';

import {
  Box,
  Button,
  Stack,
  StackProps,
  SxProps,
  Typography,
} from '@mui/material';
import moment from 'moment';
import { IUserExperience } from '../../../../../store/UserSlice';
import { TP_COLORS } from '../../../../../constants';

export const stackProps: StackProps = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  sx: {
    marginBottom: '20px',
    '&:last-child': {
      marginBottom: '0px',
    },
  },
};

export const editButtonStyles: SxProps = {
  fontWeight: '600',
  padding: '10px 20px',
  color: '#94A3B8',
};

export const deleteButtonStyles: SxProps = {
  fontWeight: '600',
  padding: '10px 20px',
  color: TP_COLORS.orange.light,
};

interface ExperienceListItemProps {
  experienceData: IUserExperience;
  handleActions: (
    type: 'edit' | 'delete',
    experienceData: IUserExperience
  ) => void;
}

const ExperienceListItem: React.FC<ExperienceListItemProps> = ({
  experienceData,
  handleActions,
}) => {
  const startYear = moment(experienceData.startDate).year();
  const endYear = moment(experienceData.endDate).year();
  const difference = Number(endYear) - Number(startYear);
  return (
    <Stack {...stackProps}>
      <Box display="flex" alignItems="center">
        <img
          src={`${process.env.PUBLIC_URL}/images/profile/icon-experience.png`}
          alt="experience-icon"
        />
        <Box marginLeft="17px">
          <Typography sx={{ color: TP_COLORS.gray.darken }}>
            {experienceData.workPlace}
          </Typography>
          <Box display="flex" sx={{ color: '#94A3B8' }}>
            <Typography marginRight="20px">
              {experienceData.jobTitle}
            </Typography>
            <Typography>
              {startYear}-{endYear}&nbsp;-&nbsp;
              {difference}&nbsp;Year{difference > 1 && 's'}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box>
        <Button
          sx={editButtonStyles}
          onClick={() => handleActions('edit', experienceData)}
        >
          Edit
        </Button>
        <Button
          sx={deleteButtonStyles}
          onClick={() => handleActions('delete', experienceData)}
        >
          Remove
        </Button>
      </Box>
    </Stack>
  );
};

export default ExperienceListItem;
